import api from "../../../api/axios";

/**
 * GET ALL SCHOOL YEARS
 */
const getSchoolYears = async () => {
  const response = await api.get("/api/v1/power/school-years");

  return response.data;
};

/**
 * GET ACTIVE SCHOOL YEAR
 */
const getActiveSchoolYear = async () => {
  const response = await api.get("/api/v1/power/school-years/active");

  return response.data;
};

/**
 * GET SINGLE SCHOOL YEAR
 */
const getSchoolYearById = async (id) => {
  const response = await api.get(`/api/v1/power/school-years/${id}`);

  return response.data;
};

/**
 * CREATE SCHOOL YEAR
 */
const createSchoolYear = async (data) => {
  const response = await api.post("/api/v1/power/school-years", data);

  return response.data;
};

/**
 * UPDATE SCHOOL YEAR
 */
const updateSchoolYear = async ({ id, data }) => {
  const response = await api.patch(`/api/v1/power/school-years/${id}`, data);

  return response.data;
};

/**
 * ACTIVATE SCHOOL YEAR
 */
const activateSchoolYear = async (id) => {
  const response = await api.patch(`/api/v1/power/school-years/${id}/activate`);

  return response.data;
};

/**
 * LOCK SCHOOL YEAR
 */
const lockSchoolYear = async (id) => {
  const response = await api.patch(`/api/v1/power/school-years/${id}/lock`);

  return response.data;
};

/**
 * UNLOCK SCHOOL YEAR
 */
const unlockSchoolYear = async (id) => {
  const response = await api.patch(`/api/v1/power/school-years/${id}/unlock`);

  return response.data;
};

/**
 * DELETE SCHOOL YEAR
 */
const deleteSchoolYear = async (id) => {
  const response = await api.delete(`/api/v1/power/school-years/${id}`);

  return response.data;
};

const schoolYearService = {
  getSchoolYears,

  getActiveSchoolYear,

  getSchoolYearById,

  createSchoolYear,

  updateSchoolYear,

  activateSchoolYear,

  lockSchoolYear,

  unlockSchoolYear,

  deleteSchoolYear,
};

export default schoolYearService;
